var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFireFilled = function SvgFireFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.594 5.048c-.78-1-2.602-3.711-3.852-4.796-1.25-1.085-2.397 4.532-3.75 6.085C4.639 7.89 3.155 4.113 2.39 5.049A6.53 6.53 0 0 0 .992 9.094c0 3.718 3.14 6.743 7 6.743s7-3.026 7-6.746a6.519 6.519 0 0 0-1.398-4.043Z",
    fill: "currentColor"
  })));
};
export default SvgFireFilled;